import React, { useState } from 'react';

import { useForm } from 'react-hook-form';

import { useMobileStore } from 'store/mobile.store';

import { useMutationUploadDocumentFile } from 'api/mutations/uploadAssociatedDocument.mutation';

import { AddAssociatedDocumentsDesktop } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/desktop/addAssociatedDocuments.desktop';
import { AddAssociatedDocumentsMobile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/mobile/addAssociatedDocuments.mobile';

export interface IFields {
    externalLink?: {
        title: string;
        url: string;
    };
    externalDocument?: {
        name: string;
        path: string;
        id: number | null;
    };
}

interface Props {
    handleClose: () => void;
    handleAddDocumentsLink: (value: IFields) => void;
    handleAddAssociatedDocumentsFiles: (value: IFields) => void;
    showAddAssociatedDocuments: boolean;
    hasExternalDocumentsProperty: boolean;
}

export type ADDITION_OPTIONS = 'addLink' | 'uploadFileFromDevice';

export const AddAssociatedDocuments = ({
    handleClose,
    showAddAssociatedDocuments,
    handleAddDocumentsLink,
    handleAddAssociatedDocumentsFiles,
    hasExternalDocumentsProperty = false,
}: Props) => {
    const [documentMode, setDocumentMode] = useState<ADDITION_OPTIONS | null>(null);
    const { mutate: uploadDocumentMutation } = useMutationUploadDocumentFile();
    const isMobile = useMobileStore((state) => state.isMobile);

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
    } = useForm<IFields>({
        defaultValues: {
            externalDocument: {
                name: '',
                id: null,
                path: '',
            },
            externalLink: {
                title: '',
                url: '',
            },
        },
    });

    const handleCancel = () => {
        reset();
        handleClose();
        setTimeout(() => setDocumentMode(null), 300);
    };

    const handleFileChosen = (uploadedFile: File) => {
        uploadDocumentMutation(uploadedFile, {
            onSuccess: (response) => {
                handleAddAssociatedDocumentsFiles({
                    externalDocument: { ...response.data },
                });
                handleCancel();
            },
            onError: () => {
                handleCancel();
            },
        });
    };

    const handleSave = (data) => {
        handleAddDocumentsLink(data);
        reset();
        setTimeout(() => setDocumentMode(null), 300);
    };

    const componentProps = {
        showAddAssociatedDocuments,
        handleCancel,
        handleSubmit,
        handleSave,
        documentMode,
        setDocumentMode,
        handleFileChosen,
        errors,
        control,
        setValue,
    };

    return isMobile ? (
        <AddAssociatedDocumentsMobile {...componentProps} />
    ) : (
        <AddAssociatedDocumentsDesktop
            {...componentProps}
            hasExternalDocumentsProperty={hasExternalDocumentsProperty}
        />
    );
};
